import { useEffect, useRef } from "react";
import "./RightSlideDialog.css";
import "./index.css";
import { XStack, YStack } from "tamagui";
import { HelpDialog } from "../webHelpDialog";
import { useAppState } from "../../core/appState/UseAppStateZustand";
import { useShallow } from "zustand/shallow";


interface Props {
  // isOpen: boolean;
  onClose: () => void;
  isSmallScreen?: boolean;
}



export const HelpLinksDialog: React.FC<Props> = ({
  // isOpen,
  onClose,
  isSmallScreen,
}) => {
  const isHelpDialogOpen = useAppState(useShallow((s) => s.isHelpDialogOpen));
  const dialogRef = useRef<HTMLElement | null>(null);
  const overlayRef = useRef<HTMLElement | null>(null);


  useEffect(() => {
    // Prevent body scroll when the dialog is open
    if (isHelpDialogOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isHelpDialogOpen]);


  return (
    <YStack
      ref={overlayRef}
      className={
        isSmallScreen
          ? `dialog-overlay-help-center ${isHelpDialogOpen ? "open" : ""}`
          : `dialog-overlay-help ${isHelpDialogOpen ? "open" : ""}`
      }
      id={"helpDialogWrapper"}
      style={{position : 'fixed'}}
      onPress={(e : any) => {
        if (isHelpDialogOpen) {
          if (
            dialogRef.current &&
            overlayRef.current &&
            //@ts-ignore
            !dialogRef.current.contains(e.target as Node) &&
            //@ts-ignore
            overlayRef.current.contains(e.target as Node)
          ) {

            //close dialog
            onClose();
          }
        }
      }}
    >
      {/* @ts-ignore */}
      <XStack
        className={"dialog-content-help" + (isSmallScreen ? "-center" : "")}
        ref={dialogRef}
        height={isSmallScreen ? "36%" : "320px"}
        overflow="visible"
      >
        <HelpDialog onClose={onClose}/>
      </XStack>
    </YStack>
  );
};
